export default interface ApiDetailModel {
  isLoading: boolean;
  selectedData: any | null;
}

export const initDetailModel: ApiDetailModel = {
  isLoading: false,
  selectedData: null,
};
